import { __rest } from "tslib";
import React from "react";
import * as Icons from "../Icons";
import * as S from "./styles";
export function TertiaryLink(e) {
  var r = e.href,
      t = e.children,
      o = e.component,
      n = e.isHovered,
      a = __rest(e, ["href", "children", "component", "isHovered"]);

  return r ? React.createElement(S.TertiaryLink, Object.assign({
    as: o,
    href: r,
    hover: n
  }, a), t, React.createElement(Icons.RightArrow, null)) : React.createElement(S.TertiaryText, Object.assign({
    as: o,
    hover: n
  }, a), t, React.createElement(Icons.RightArrow, null));
}
export default TertiaryLink;